import { Component, OnInit, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-new-activity',
  templateUrl: './new-activity.component.html',
  styleUrls: ['./new-activity.component.css']
})
export class NewActivityComponent implements OnInit {
  @Input() open: Boolean;
  @Input() data: any;
  @Output() close = new EventEmitter<boolean>();
  @Output() logmanually = new EventEmitter<any>();
  timer: Boolean = false;
  modalRef: BsModalRef;
  seconds = 0;
  initialValue = '';
  interval;
  categories: Array<any> = [];
  activities: Array<any> = [];
  goals: Array<any> = [];
  outcomes: Array<any> = [];
  preoutcomes: Array<any> = [];
  postoutcomes: Array<any> = [];
  profileForm = new FormGroup({
    category: new FormControl('', [Validators.required]),
    goal: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    outcome: new FormControl(null),
    timeLogged: new FormControl(''),
    startTime: new FormControl(''),
    endTime: new FormControl(''),
    loggedBy: new FormControl(this.apiservice.user._id),
    ratings: new FormControl(0),
    cost: new FormControl(0),
    preoutcomes: new FormControl([]),
    preoutcomeValue: new FormControl(null),
    postoutcomes: new FormControl([]),
    postoutcomeValue: new FormControl(null)
  });
  constructor(
    public translations: TranslationService,
    private apiservice: ApiService,
    private modalService: BsModalService
  ) { }

  ngOnChanges(changes) {
    this.getData();
  }

  ngOnInit() {
    this.getData();
    this.apiservice.getActivities().subscribe((res: any) => {
      this.activities = res.data;
    });
  }

  getData() {
    if (this.apiservice.user.profiles) {
      this.apiservice.getProfileById(this.apiservice.user.profiles._id, this.apiservice.user._id, true).subscribe((res: any) => {
        this.categories = res.data.categoryMap.map(cat => {
          cat['category']['goals'] = cat['goals'];
          return cat;
        });
        this.categories.sort(function(a, b) {
          return a.rank - b.rank;
        });
        if (this.data) {
          this.profileForm.patchValue({ category: this.data.category, goal: this.data.goal, outcome: this.data.outcome });
          if(this.data.activity){
            this.profileForm.patchValue({ name: this.data.activity });
          }
          let index = this.categories.findIndex(data => data.category._id == this.data.category);
          this.goals = this.categories[index]['category']['goals'];
          let index1 = this.goals.findIndex(data => data._id == this.data.goal);
          this.outcomes = this.goals[index1]['outcomes'];
          if (this.data.actTitle) {
            this.profileForm.patchValue({ name: this.data.actTitle });
          }
        }
      })
    } else {
      this.apiservice.getCreatedCategories(this.apiservice.user._id, 'all').subscribe((res: any) => {
        this.categories = res.data.map(cat => {
          cat['category'] = cat;
          return cat;
        });
        if (this.data) {
          this.profileForm.patchValue({ category: this.data.category, goal: this.data.goal, outcome: this.data.outcome });
          if(this.data.activity){
            this.profileForm.patchValue({ name: this.data.activity });
          }
          let index = this.categories.findIndex(data => data.category._id == this.data.category);
          this.goals = this.categories[index]['category']['goals'];
          let index1 = this.goals.findIndex(data => data._id == this.data.goal);
          this.outcomes = this.goals[index1]['outcomes'];
          if (this.data.actTitle) {
            this.profileForm.patchValue({ name: this.data.actTitle });
          }
        }
      });
    }
  }

  selectEvent(item, template: TemplateRef<any>) {
    this.apiservice.getCheckLists(item._id).subscribe((res: any) => {
      if (res.data.preoutcomes) {
        this.preoutcomes = res.data.preoutcomes;
      }
      if (res.data.postoutcomes) {
        this.postoutcomes = res.data.postoutcomes;
      }
      if (this.preoutcomes.length > 0) {
        this.modalRef = this.modalService.show(template);
      }
    })
    this.profileForm.patchValue({ name: item.title });
  }

  preOutcomeChange(e, outcome) {
    let preoutcome = this.profileForm.value.preoutcomes;
    if (e.target.checked) {
      preoutcome.push(outcome._id);
      this.profileForm.patchValue({ preoutcomes: preoutcome });
      return
    }
    let index = preoutcome.findIndex(el => el == outcome._id);
    preoutcome.splice(index, 1);
    this.profileForm.patchValue({ preoutcomes: preoutcome });
    return
  }
  preOutcomeValue(e) {
    this.profileForm.patchValue({ preoutcomeValue: e.target.value });
    return;
  }

  onChangeSearch(search: string) {
    this.profileForm.patchValue({ name: search });
  }

  setGoals(event) {
    let index = this.categories.findIndex(data => data.category._id == event.target.value);
    this.goals = this.categories[index]['category']['goals'];
  }

  setOutcomes(event) {
    let index = this.goals.findIndex(data => data._id == event.target.value);
    this.outcomes = this.goals[index]['outcomes'];
  }

  startTimer() {
    if (!this.profileForm.valid) {
      return
    }
    this.timer = true;
    this.profileForm.patchValue({ 'startTime': new Date() });
    this.interval = setInterval(() => {
      this.seconds += 1;
    }, 1000);
  }


  stopTimer() {
    this.timer = false;
    clearInterval(this.interval);
    this.profileForm.patchValue({ 'endTime': moment(this.profileForm.value['startTime']).add(this.seconds, 'seconds').toDate(), 'timeLogged': this.seconds });
    this.seconds = 0;
    this.logmanually.emit({ activityData: this.profileForm.value, postoutcomes: this.postoutcomes });
    this.profileForm.patchValue({ startTime: '', endTime: '', postoutcomes: [], preoutcomes: [] });
  }

  getH() {
    return moment.utc(this.seconds * 1000).format('HH');
  }

  getM() {
    return moment.utc(this.seconds * 1000).format('mm');
  }

  getS() {
    return moment.utc(this.seconds * 1000).format('ss');
  }

  enterTimeManually() {
    if (!this.profileForm.valid) {
      return
    }
    this.logmanually.emit({ activityData: this.profileForm.value, postoutcomes: this.postoutcomes });
    this.profileForm.patchValue({ startTime: '', endTime: '', postoutcomes: [], preoutcomes: [] });

  }

}
